import React from 'react';
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import Avatar from '@mui/material/Avatar';
import {ListItemAvatar, ListItemText} from '@mui/material';
import {createdDate} from '@bidmii/common/lib/util/DateUtils';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import {securedFetchRequest} from '@bidmii/common/lib/util/FetchRequest';
import {useHistory} from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import BidmiiTooltip from '../../../common/StyledComponents/BidmiiTooltip';

const useStyles = makeStyles((theme) => ({
  listItemRoot: {
    color: theme.palette.primary.main,
  },
  listItemTextPrimary: {
    color: theme.palette.primary.main,
    fontSize: '15px',
    fontFamily: 'AeonikProReqular',
    paddingBottom: '3px',
  },
  listItemTextSecondary: {
    fontSize: '12px',
    fontFamily: 'AeonikProReqular',
    textTransform: 'uppercase',
    color: 'rgba(0, 0, 0, 0.5)',
  },
  large: {
    width: theme.spacing(8),
    height: theme.spacing(8),
    cursor: 'pointer',
    borderRadius: 6,
  },
  box: {
    borderBottom: `2px solid ${theme.palette.gray.border}`,
    '&:hover': {
      background: theme.palette.gray.main,
    },
  },
  red: {
    width: theme.spacing(1.5),
    height: theme.spacing(1.5),
    backgroundColor: 'red',
    color: 'red',
    marginRight: '10px',
  },
  invisible: {
    width: theme.spacing(1.5),
    height: theme.spacing(1.5),
    backgroundColor: 'rgba(0, 0, 0, 0)',
    color: 'rgba(0, 0, 0, 0)',
    marginRight: '10px',
  },
}));

function NotificationItem(props: $TSFixMe) {
  const history = useHistory();
  const classes = useStyles();
  const notification = props.notification;

  const handleClearNotification = () => {
    const url = notification._links.self.href;
    const body = {
      enabled: false,
    };
    securedFetchRequest(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((res) => {
        const index = props.notifications.findIndex(
          (item: $TSFixMe) => item.id === notification.id,
        );
        props.notifications.splice(index, 1);
        const items = [...props.notifications];
        props.setNotifications(items);
      });
  };

  const handleClickItem = () => {
    const url = notification._links.self.href;
    const body = {
      has_been_read: true,
    };
    securedFetchRequest(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((res) => {
        const items = [...props.notifications];
        const index = items.findIndex((item) => item.id === notification.id);
        if (index > 0) {
          try {
            const currentNotification = items[index];
            if (!currentNotification.hasBeenRead) {
              items[index].hasBeenRead = true;
            }
          } catch (e) {}
        }
        props.getNotifications();
        props.onClose();
        props.setNotifications(items);
        if (notification.url != null) {
          history.push(`/${notification.url}`);
        } else {
          history.push('/');
        }
      });
  };

  return (
    <Box
      className={classes.box}
      key={`notification_container_${notification.id}`}>
      <ListItem
        ContainerComponent="div"
        key={`notification_item_${notification.id}`}>
        {notification.hasBeenRead ? (
          <Avatar className={classes.invisible} />
        ) : (
          <Avatar className={classes.red} />
        )}
        <ListItemAvatar>
          <Avatar
            className={classes.large}
            src={
              notification.imgUrl === null
                ? 'https://cdn.bidmii.com/media/web_assets/nullNotificationImage.png'
                : notification.imgUrl
            }
            alt="notification rfp"
            variant="square"
            onClick={handleClickItem}
          />
        </ListItemAvatar>
        <ListItemText
          classes={{
            primary: classes.listItemTextPrimary,
            secondary: classes.listItemTextSecondary,
          }}
          primary={notification.title}
          secondary={createdDate(notification.createdDate)}
          style={{cursor: 'pointer', paddingLeft: '12px'}}
          onClick={handleClickItem}
        />
        <ListItemSecondaryAction>
          <BidmiiTooltip title="Clear Notification">
            <IconButton
              edge="end"
              aria-label="delete"
              onClick={handleClearNotification}
              size="large">
              <ClearIcon />
            </IconButton>
          </BidmiiTooltip>
        </ListItemSecondaryAction>
      </ListItem>
    </Box>
  );
}

export default NotificationItem;
